import Rive, { Fit, Layout } from '@rive-app/react-canvas'
import '../../../lib/Styles/rive.css'

const LoadingAnimationForLab = () => {
  const riveLayout = new Layout({ fit: Fit.Cover })
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <figure className="w-full h-full object-cover">
        <Rive
          src="https://s3.brilliant.com.bd/blog-bucket/riveavatar/2010b68d-ee1d-433a-a510-58cee4c4d551.riv"
          stateMachines="State Machine 1"
          layout={riveLayout}
          className="rive-canvas w-full h-full object-cover"
        />
      </figure>
    </div>
  )
}

export default LoadingAnimationForLab
